<template>
  <div style="height: calc(100vh - 83px)" class="bg-white relative">
    <div class="telephone-interview bg-white relative">
      <!-- 最上面的一个 banner 图 -->
      <!-- <div>
        <div class="banner">
          <img src="@/assets/img/telephone-interview/topBanner.png" />
        </div>
      </div> -->
      <!-- 【添加调查员】按钮 -->
      <!-- <el-button class="absolute top-4 left-4" type="primary" @click="addInterviewer" v-show="flag">添加调查员</el-button> -->
      <!-- 下面的表格 -->
      <div class="basic-content" style="height: calc(100vh - 100px)">
        <!-- 选中的调查员表格 -->
        <selected-interviewer
          class=""
          :importBool="importBool"
          @importTable="importTable"
          :inputPlaceholder="inputPlaceholderOptions"
          :taskStatus="taskStatusOptions"
          :tableColumnName="tableColumnNameOptions"
          :propTableData="tableData"
          :combineField="combineFieldOptions"
          @inputValueChange="getTableData"
          channel="telephoneInterviewer"
          :total="total"
          :searchRight="true"
          @flag="getflag"
          :switchChangeFunc="putTaskSwitch"
          :parseParamsFunc="parseParams"
          :successFunc="successHandler"
          :newField="newFieldOptions"
          @changeDialogVisible="() => (dialogVisible = true)"
          @welcomeAddInterviewer="() => (this.addInterviewer())"
          :propsWelcomeShow="propsWelcomeShow"
          :activeCallType="activeCallType"
          :predictCall.sync="predictCall"
          >
          <template slot="selected-left">
            <div class="z-10 inline-block" :style="`width: ${activeCallType === 5 ? '310' : '110'}px;`" v-show="flag">
              <el-button class="" type="primary" @click="addInterviewer(true)">添加调查员</el-button>
              <template v-if="activeCallType === 5">
                <el-divider direction="vertical"></el-divider>
                <span class="text-medium text-theme-black-850 mr-1">预测式外呼任务开关</span>
                <el-switch
                  v-model="predictCall" @change="changePredictCallStatus"
                ></el-switch>
              </template>
            </div>
          </template>
        </selected-interviewer> 
        <!-- 报名的调查员表格 -->
        <!-- <signup-interviewer v-else-if="activeIndex === '2'" @handlerSum="handlerSumHandler"/> -->
      </div>
    </div>

    <!-- <cati-comp v-show="pageState === 0"/> -->
    <el-drawer
      title="添加调查员"
      :visible.sync="addDrawer"
      size="83%"
      :destroy-on-close="true"
      :before-close="handleAddDrawerClose"
    >
      <PhoneTask :activeCallType="activeCallType" :isHaveTask="isHaveTask" @emitDialog="changeOverDialog" @cancel="handleAddDrawerClose"></PhoneTask>
    </el-drawer>
    <over-mask
      :dialogVisible="dialogVisible"
      @handleClose="
        () => {
          dialogVisible = false
        }
      "
    ></over-mask>
  </div>
</template>

<script>
import { getPhoneList, creatPhoneTask, putTask, putTaskSwitch, phoneListExcel, getPredictCallStatus, changePredictCallStatus } from '@/api/wenjuan/telephone.js'
import selectedInterviewer from '../offline/components/SelectedInterviewer.vue'
import { inputPlaceholderOptions, taskStatusOptions, tableColumnNameOptions, newFieldOptions } from './option.js'
import CatiComp from './components/CatiComp.vue'
import GlobalConfig,{ AuthConfig } from '@/global/config'
import PhoneTask from './components/task/PhoneTask'
import OverMask from '@/views/survey/offline/components/overMask/OverMask.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    selectedInterviewer,
    CatiComp,
    PhoneTask,
    OverMask
  },
  data() {
    return {
      // 调查员id
      investigatorId: 0,
      importBool: 'import',
      flag: true,
      addDrawer: false,
      // activeIndex: '1'
      inputPlaceholderOptions: {},
      taskStatusOptions: [],
      tableColumnNameOptions: {},
      // telephoneLoading: false,
      combineFieldOptions: {
        name: 'executorName',
        concat: 'executorPhone',
        id: 'id'
      },
      newFieldOptions: {},

      tableData: [],
      putTaskSwitch: new Function(),
      total: 0,
      pageState: '',
      dialogVisible: false,
      propsWelcomeShow: false,
      predictCall: false,
      activeCallType: null,
      isHaveTask: null //是否已经有任务
    }
  },
  methods: {
    importTable() {
      let obj = {
        surveyId: GlobalConfig.getSurveyId()
      }
      phoneListExcel(obj)
        .then(res => {
          let url = res.data.data
          if (url) {
            window.open(url)
          } else {
            this.$message.error('导出失败')
          }
        })
        .catch(err => {
          this.$message.error('导出失败')
        })
    },
    getflag(v) {
      this.flag = v
    },
    handleAddDrawerClose() {
      this.addDrawer = false
      this.getTableData().then(()=> {
        this.propsWelcomeShow = this.total === 0
      })
    },
    getTableData(temParams) {
      let defaultParams = {
        surveyId: GlobalConfig.getSurveyId(),
        id: this.investigatorId !== 0 ? this.investigatorId : null,
        current: 1,
        size: 20
      }
      let params = Object.assign({}, defaultParams)

      if (temParams) {
        temParams.commonName && (params.executorName = temParams.commonName)
        temParams.commonPhone && (params.executorPhone = temParams.commonPhone)
        temParams.commonTaskName && (params.executionName = temParams.commonTaskName)
        temParams.taskStatusValue && (params.status = temParams.taskStatusValue)
        temParams.chengjiezhuangtai && (params.chengjiezhuangtai = temParams.chengjiezhuangtai)
        params.current = temParams.current
      }
      return getPhoneList(params)
        .then(res => {
          // console.log('res: ', res);
          this.total = res.data.data.total

          this.pageState = this.total == 0 ? 0 : 1 // 页面状态 0：无数据 1：有数据
          // console.log('this.pageState: ', this.pageState);
          // if(!this.total) return;

          // 处理数据
          // 在每条数据上加上 show 和 edit 字段 之后表格操作会用到

          // this.propsWelcomeShow = res.data.data.records.length == 0 ? true : false
          this.tableData = res.data.data.records.map(item => {
            // 新增的两个字段
            item.show = false
            item.edit = true

            // 修改字段 变成组件统一的 prop
            item.equalName = item.executorName
            item.equalPhone = item.executorPhone
            item.equalTaskName = item.executionName
            item.equalState = item.status
            item.equalTaskEndTime = item.executionValidateTo
            item.equalCount = item.executionQuantity
            item.equalPrice = item.executionSingleAmount
            item.equalCommitCount = item.recycledQuantity
            item.equalEffectiveCount = item.effectiveQuantity

            // item.settleMode = 1;
            // item.settleRule ={
            //     "tiers": [
            //       {
            //         "unitPriceYuan": 10,
            //         "quantityLowerBound": 1,
            //         "quantityUpperBound": 100
            //       },
            //       {
            //         "unitPriceYuan": 20,
            //         "quantityLowerBound": 101,
            //         "quantityUpperBound": 200
            //       },
            //       {
            //         "unitPriceYuan": 30,
            //         "quantityLowerBound": 201,
            //         "quantityUpperBound": 300
            //       }
            //     ],
            //     "unitPriceYuan": 1,
            //     "expectedQuantity": 1
            //   }

            if (item.status == 7 || item.status == 8) {
              item.isOpen = false
            } else {
              item.isOpen = true
            }
            return item
          })
          //同一个问卷中的电话调查任务，若已选择一个任务类型，后续再添加任务，仅支持添加相同类型任务，另一个选项置灰
          if(this.tableData.length) {
            this.activeCallType = this.tableData[0].jobForm
          }else {
            this.activeCallType = null
          }
        })
        .catch(e => {
          this.$message.error('获取数据失败')
          console.log(e.message)
        })
        .finally(() => {
          // this.telephoneLoading = false;
        })
    },
    addInterviewer(flag = false) {
      // if([AuthConfig.PersonalPlus].includes(GlobalConfig.getAuthCode())){
      //   if(this.tableData?.length < 1){
      //     this.addDrawer = true
      //   }else{
      //     this.$message.warning('当前版本暂时只能创建一条数据');
      //   }
      // }else 
      if([AuthConfig.TeamBase, AuthConfig.TeamPlus].includes(GlobalConfig.getAuthCode())){
        this.addDrawer = true
        this.isHaveTask = flag
      }else{
        this.$message.warning('当前版本暂时无法创建,请升级版本');
      }
      // this.$router.push(`/survey/${GlobalConfig.getSurveyId()}/cati/cati-interview/phone-task`)
    },
    handleSelect() {},
    addArrangeParamsHandler() {},
    successHandler(row) {
      let status = row.isOpen ? 6 : 7
      row.status = status
    },
    parseParams(row, batchFlag) {
      batchFlag = batchFlag ? 1 : 0
      return { idList: [row.id], batchFlag, explanation: '' }
    },
    init() {
      this.inputPlaceholderOptions = inputPlaceholderOptions
      this.newFieldOptions = newFieldOptions
      this.tableColumnNameOptions = tableColumnNameOptions
      this.taskStatusOptions = taskStatusOptions
      this.putTaskSwitch = putTaskSwitch
      console.log('tableColumnNameOptions',tableColumnNameOptions)
    },
    createTelephoneTask() {
      creatPhoneTask({
        execution: {
          executionName: '任务名称',
          surveyId: GlobalConfig.getSurveyId(),
          executionQuantity: 1,
          executionSingleAmount: 3,
          executionValidateTo: '2021-04-02 00:00:00',
          executionDescription: '任务描述',
          userList: [
            {
              userId: '1',
              userName: '调查员',
              phone: '15540101111',
              justForCode: 'true'
            }
          ]
        },
        phoneList: [
          {
            phoneNumber: '15540101111',
            sampleName: 'da'
          }
        ]
      })
        .then(res => {
          this.$message.success('创建面访任务成功')
        })
        .catch(e => {
          this.$message.error(e.message)
        })

      this.getTableData()
    },
    changeOverDialog(val) {
      this.dialogVisible = val
    },
    getPredictSwitch() {
      getPredictCallStatus({surveyId: GlobalConfig.getSurveyId()}).then(res=> {
        this.predictCall = res.data.data?.enable??false
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    changePredictCallStatus(val) {
      changePredictCallStatus({surveyId: GlobalConfig.getSurveyId(), enable: val}).then(res => {
        if(res.data.code === 0) {
          this.$message.success('操作成功')
          this.getPredictSwitch()
          this.getTableData()
          return
        }
        this.$message.error(res.data.msg || '操作失败')
        this.getPredictSwitch()
      }).catch(err => {
        this.$message.error(err.message)
      })
    }
  },
  computed: {
    ...mapGetters(['catiOpenStatus'])
  },
  created() {
    if (this.$route.query.id) {
      this.investigatorId = Number(this.$route.query.id)
    }
    // if(this.catiOpenStatus) {
    // this.telephoneLoading = true;
    this.getTableData().then(()=> {
      console.log('this.total',this.total)
      this.propsWelcomeShow = this.total === 0
    })
    this.init()
    this.getPredictSwitch()
    // }
  }
}
</script>

<style lang="scss" scoped>
.telephone-interview {
  .banner {
    img {
      width: 100%;
      height: 100%;
    }
  }

  .basic-content {
    // ::v-deep .el-card__body {
    //   min-height: calc(100vh - 350px) !important;
    // }
  }
}
.isNotQy {
  height: calc(100vh - 56px);
}
</style>
